export default {
	login: 'Iniciar sesión'
}